import "../../styles/popoverOverride.scss";
import "./inspectorConstraints.scss";
import "./inspectorAttachments.scss";

import PropTypes from "prop-types";
import React from "react";

import { PropTypeShapes } from "../../types";
import FormButton from "../form/FormButton";
import FormListButtonWrapper from "../form/FormListButtonWrapper";
import Icon from "../interface/Icon";
import InspectorAttachmentPopover from "./InspectorAttachmentPopover";

class InspectorAttachmentList extends React.PureComponent {
  constructor(props) {
    super(props);
    this._isChildPopoverOn = false;
    this.toggle = this.toggle.bind(this);
    this.onChildPopover = this.onChildPopover.bind(this);
    this.state = {
      popoverOpen: false
    };
  }

  onTogglePopover(value) {
    const { onTogglePopover } = this.props;
    if (onTogglePopover) {
      onTogglePopover(value);
    }
  }

  toggle() {
    if (!this.props.popover) {
      this.props.onAddNew();
    } else if (!this._isChildPopoverOn) {
      const { popoverOpen } = this.state;
      this.setState({
        popoverOpen: !popoverOpen
      });
      this.onTogglePopover(!popoverOpen);
    }
  }

  onChildPopover(value) {
    this._isChildPopoverOn = value;
  }

  render() {
    return (
      <div className="inspectorAttachmentList">
        {this.props.values.map(attachment =>
          RenderAttachmentItem(
            attachment.label,
            attachment.url,
            this.props.onRemove,
            this.props.onItemClick,
            attachment.id
          )
        )}
        <div id={`${this.props.id}-add`}>
          <FormListButtonWrapper className="attachmentAddWrapper" onClick={this.toggle}>
            <Icon className="addAttachment" icon="listAdd" color="iconMono" />
          </FormListButtonWrapper>
        </div>
        {this.props.popover ? (
          <InspectorAttachmentPopover
            visible={this.state.popoverOpen}
            onAddClick={this.props.onAddNew}
            onBrowseClick={this.props.onBrowseClick}
            target={`${this.props.id}-add`}
            toggle={this.toggle}
            label={true}
            showBrowse={this.props.showBrowse}
            title={this.props.title}
            backText={this.props.backText}
          />
        ) : null}
      </div>
    );
  }
}

const RenderAttachmentItem = (title, url, onRemove, onClick, id) => {
  const onClickInner = () => onClick(id);
  const titleEl = title ? <FormButton linkStyle={true} label={title} onClick={onClickInner} /> : null;
  const urlEl = url ? (
    title ? (
      <span className="inspectorConstraintContentTitle">{url}</span>
    ) : (
      <FormButton linkStyle={true} label={url} onClick={onClickInner} />
    )
  ) : null;
  return (
    <div className="inspectorConstraintBox" key={`list-item-${id}`}>
      <div className="inspectorConstraintContent">
        {titleEl}
        {urlEl}
      </div>
      <Icon className="deleteIcon" icon="listDelete" color="iconMono" onClick={() => onRemove(id)} />
    </div>
  );
};

InspectorAttachmentList.propTypes = {
  values: PropTypeShapes.attachmentListValueArray.isRequired,
  popover: PropTypes.bool,
  showBrowse: PropTypes.bool,
  id: PropTypes.string,
  onAddNew: PropTypes.func,
  onRemove: PropTypes.func,
  onItemClick: PropTypes.func,
  onBrowseClick: PropTypes.func,
  title: PropTypes.string,
  backText: PropTypes.string,
  onTogglePopover: PropTypes.func
};

export default InspectorAttachmentList;
